import { gql } from '__generated__'

export const GetProcessStatusOptions = gql(/* GraphQL */ `
    query GetProcessStatusOptions {
        processStatuses {
            id
            status
            statusLabel
            processStatusSummaryGroup {
                id
                summaryGroup
                label
            }
        }
    }
`)
